"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultIfNullish = void 0;
/**
 * returns the incoming expression if the result is not nullish (undefined/null)
 * otherwise it will return the given default value
 *
 * useDefaultIfNullish(arrayOrUndefined?.length, 0) => will return 0 if the array is not defined
 *
 */
const useDefaultIfNullish = (v, d) => {
    return v !== null && v !== void 0 ? v : d;
};
exports.useDefaultIfNullish = useDefaultIfNullish;
//# sourceMappingURL=use-default-if-nullish.js.map